document.addEventListener("DOMContentLoaded", function () {
    const navbar = document.querySelector(".navbar");
    window.onscroll = function (e) {
        if (window.scrollY > 50) {
            navbar.classList.add("bg-light", "shadow-sm");
        } else {
            navbar.classList.remove("bg-light", "shadow-sm");
        }
    };

    [...document.querySelectorAll('[data-bs-toggle="tooltip"]')].forEach((el) => new bootstrap.Tooltip(el));

    [...document.querySelectorAll('[data-bs-toggle="popover"]')].forEach((el) => new bootstrap.Popover(el));

    document.querySelectorAll(".team-more").forEach(function (toggleLink) {
        toggleLink.addEventListener("click", function (event) {
            event.preventDefault();

            const teamDn = toggleLink.closest(".team-dn");
            const teamPart = teamDn.querySelector(".team-part");
            const teamFull = teamDn.querySelector(".team-full");
            const isHidden = teamFull.style.display === "none";
            if (isHidden) {
                teamFull.style.display = "inline";
                teamPart.style.display = "none";
                toggleLink.textContent = "Свернуть";
            } else {
                teamFull.style.display = "none";
                teamPart.style.display = "inline";
                toggleLink.textContent = "Читать далее";
            }
        });
    });

});

// увеличить шрифт
// Настройки
const fontSettings = {
    defaultSize: 16,
    minSize: 12,
    maxSize: 24,
    step: 1.1,
};

// Основная функция изменения шрифта
function adjustFontSize(direction) {
    const root = document.documentElement;
    let current = parseFloat(getComputedStyle(root).fontSize) || fontSettings.defaultSize;
    let newSize;

    switch (direction) {
        case "increase":
            newSize = current >= fontSettings.maxSize ? fontSettings.defaultSize : Math.min(current * fontSettings.step, fontSettings.maxSize);
            break;
        case "decrease":
            newSize = current <= fontSettings.minSize ? fontSettings.defaultSize : Math.max(current / fontSettings.step, fontSettings.minSize);
            break;
        default:
            newSize = fontSettings.defaultSize;
    }

    root.style.fontSize = `${newSize}px`;
    updateElementsWithExplicitSizes(current, newSize);
    updateButtonStates(newSize);
}

// Применение размера шрифта и сохранение
function applyFontSize(size) {
  const root = document.documentElement;
  const oldSize = parseFloat(getComputedStyle(root).fontSize) || fontSettings.defaultSize;
  
  root.style.fontSize = `${size}px`;
  updateElementsWithExplicitSizes(oldSize, size);
  updateButtonStates(size);
  
  // Сохраняем в localStorage (кроме значения по умолчанию)
  if (size === fontSettings.defaultSize) {
    localStorage.removeItem(fontSettings.storageKey);
  } else {
    localStorage.setItem(fontSettings.storageKey, size.toString());
  }
}

// Обновление элементов с явными размерами
function updateElementsWithExplicitSizes(oldRootSize, newRootSize) {
    const ratio = newRootSize / oldRootSize;
    document.querySelectorAll('[class*="fs-"]').forEach((el) => {
        const current = parseFloat(getComputedStyle(el).fontSize);
        if (current) el.style.fontSize = `${current * ratio}px`;
    });
}

// Обновление состояния кнопок
function updateButtonStates(currentSize) {
    const current = currentSize || parseFloat(getComputedStyle(document.documentElement).fontSize) || fontSettings.defaultSize;
    document.getElementById("decreaseFontBtn").disabled = current <= fontSettings.minSize;
    document.getElementById("increaseFontBtn").disabled = current >= fontSettings.maxSize;
}

// Загрузка сохраненного размера шрифта
function loadSavedFontSize() {
  const savedSize = localStorage.getItem(fontSettings.storageKey);
  if (savedSize) {
    const size = parseFloat(savedSize);
    // Проверяем, что размер в допустимых пределах
    if (size >= fontSettings.minSize && size <= fontSettings.maxSize) {
      applyFontSize(size);
      return;
    }
  }
  applyFontSize(fontSettings.defaultSize);
}

// Инициализация
document.addEventListener("DOMContentLoaded", () => {
    // Назначение обработчиков
    document.getElementById("increaseFontBtn").addEventListener("click", () => adjustFontSize("increase"));
    document.getElementById("decreaseFontBtn").addEventListener("click", () => adjustFontSize("decrease"));
    // document.getElementById("resetFontBtn").addEventListener("click", () => adjustFontSize()); 

    updateButtonStates();
});
    